import AltenarApi from './AltenarApi/AltenarApi'
import AuthApi from './AuthApi'
import BetbyApi from './BetbyApi/BetbyApi'
import BonusHistoryApi from './BonusHistoryApi/BonusHistoryApi'
import BonusSystemApi from './BonusSystem/BonusSystem'
import CollectorApi from './CollectorApi/CollectorApi'
import DigitainApi from './DigitainApi/DigitainApi'
import JackpotsApi from './JackpotsApi/JackpotsApi'
import PaymentApi from './PaymentApi/PaymentApi'
import ProfileApi from './ProfileApi/ProfileApi'
import PromocodeApi from './PromocodeApi/PromocodeApi'
import SettingsApi from './SettingsApi/SettingsApi'
import SliderApi from './SliderApi/SliderApi'
import SoftionApi from './SoftionApi'
import UpgamingApi from './UpgamingApi'
import WheelGameApi from './WheelGameApi/WheelGameApi'

class Api {
  public auth: AuthApi

  public settings: SettingsApi

  public profile: ProfileApi

  public payment: PaymentApi

  public promocode: PromocodeApi

  public bonusHistory: BonusHistoryApi

  public wheelGame: WheelGameApi

  public bonusSystem: BonusSystemApi

  public collector: CollectorApi

  public softion: SoftionApi

  public altenar: AltenarApi

  public digitain: DigitainApi

  public slider: SliderApi

  public jackpots: JackpotsApi

  public betby: BetbyApi

  public upgaming: UpgamingApi

  constructor(baseUrl = '') {
    this.auth = new AuthApi(baseUrl)
    this.settings = new SettingsApi(baseUrl)
    this.profile = new ProfileApi(baseUrl)
    this.payment = new PaymentApi(baseUrl)
    this.promocode = new PromocodeApi(baseUrl)
    this.bonusHistory = new BonusHistoryApi(baseUrl)
    this.wheelGame = new WheelGameApi(baseUrl)
    this.jackpots = new JackpotsApi(baseUrl)
    this.bonusSystem = new BonusSystemApi(baseUrl)
    this.collector = new CollectorApi(baseUrl)
    this.softion = new SoftionApi(baseUrl)
    this.altenar = new AltenarApi(baseUrl)
    this.digitain = new DigitainApi(baseUrl)
    this.slider = new SliderApi(baseUrl)
    this.betby = new BetbyApi(baseUrl)
    this.upgaming = new UpgamingApi(baseUrl)
  }
}

export default Api
